import { Row, Button, Form, Col, Dropdown } from "react-bootstrap";
import { RootState } from "redux/store";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import { BulkEdit } from "./Popups/BulkEdit";
import { useEffect, useRef, useState } from "react";
import { getStores } from "redux/slices/Stores";
import { updateAssignPriceGroupField, getPriceGroupsStore, modifyPriceGroupsStore, applyPriceGroupsStore, addAGGridSelectedStock } from "redux/slices/AssignPriceGroup";
import { getDepartments } from "redux/slices/Departments";
import { Spinner, Modal } from "components";
import { getSubDepartments } from "redux/slices/SubDepartment";
import { getStockGroups } from "redux/slices/StockGroups";
import { AgGridReact } from "ag-grid-react";
import { getPriceGroupStockConfig, getPriceGroupStockCsvDataFormatter, getPriceGroupStockDataFormatter } from "TableConfigs/PriceGroupStockConfig";
import BaseCellRenderer from "components/AgGrid/CellRenderers/BaseCellRenderer";
import PriceCellRenderer from "components/AgGrid/CellRenderers/PriceCellRenderer";
import PercentCellRenderer from "components/AgGrid/CellRenderers/PercentCellRenderer";
import { IServerSideDatasource } from "ag-grid-enterprise";
import { AgGridToolbar, AgGridToolbarRef } from "components/AgGrid/AgGridToolbar";
import { Z } from "models/common/components";
import { ZTooltip } from "components/ZTooltip";
import { ZIconType } from "helpers/utility/iconMap";
import { ZIcon } from "components/ZIcon";
import { getExportCoverPage, getExportStyles } from "TableConfigs/CoverPageSetup";

type stockProps = {
    display: boolean;
    updateTab: (tab: string) => void;
}
export default function StockPriceGroup({ display, updateTab }: stockProps) {
    const dispatch = useAppDispatch();
    const [saving, setSaving] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [bulkEditShow, setBulkEditShow] = useState(false);
    const [disableModal, setDisableModal] = useState(false);
    const stores = useAppSelector((state: RootState) => state.stores);
    const stockGroups = useAppSelector((state: RootState) => state.stockGroups);
    const priceGroups = useAppSelector((state: RootState) => state.priceGroups);
    const departments = useAppSelector((state: RootState) => state.department);
    const subDepartments = useAppSelector((state: RootState) => state.subDepartment);
    const storeGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
    const assignPriceGroup = useAppSelector((state: RootState) => state.assignPriceGroup);
    const user = useAppSelector((state: RootState) => state.logedinUser);

    const stockPriceGroupGridRef = useRef<AgGridReact>(null);
    const toolbarRef = useRef<AgGridToolbarRef>(null);


    useEffect(() => {
        dispatch(getDepartments());
    }, []);

    useEffect(()=>{
        if(stockPriceGroupGridRef.current !== undefined && stockPriceGroupGridRef.current?.api !== undefined){
            stockPriceGroupGridRef.current?.api.setGridOption("serverSideDatasource", getServerSideDatasource());
            stockPriceGroupGridRef.current?.api.clearRangeSelection();
        }
        },[assignPriceGroup.keyword])

    useEffect(() => {
        if (display === true && assignPriceGroup.currentStore > 0 && assignPriceGroup.activeTab === 3) getStocksList();
        if (assignPriceGroup.currentDepartment === 0) {
            dispatch(updateAssignPriceGroupField({ key: "currentSubDepartment", value: 0 }));
        } else {
            dispatch(getSubDepartments(assignPriceGroup.currentDepartment));
        }
    }, [assignPriceGroup.currentStore, assignPriceGroup.currentDepartment, display, assignPriceGroup.currentSubDepartment, assignPriceGroup.activeTab, assignPriceGroup.managedStockGroupId, storeGroupId]);

    useEffect(() => {
        if (assignPriceGroup.currentStore === 0 && assignPriceGroup.activeTab === 3) {
            dispatch(updateAssignPriceGroupField({ key: "error", value: "Please select a store to continue." }));
            stockPriceGroupGridRef.current?.api.showNoRowsOverlay();
        } else {
            dispatch(updateAssignPriceGroupField({ key: "error", value: "" }));
        }
    }, [assignPriceGroup.currentStore, assignPriceGroup.activeTab]);

    async function getStocksList() {
        if (assignPriceGroup.currentStore > 0) {
            dispatch(getStores({ storeGroupIds: [storeGroupId] }));
            dispatch(getDepartments());
            dispatch(getStockGroups());           
            stockPriceGroupGridRef.current?.api.setGridOption("serverSideDatasource", getServerSideDatasource());
            stockPriceGroupGridRef.current?.api.clearRangeSelection();
        }
    }

/// Does the api call for report data. also handles grouping requests
    const getServerSideDatasource: () => IServerSideDatasource = () => {
        return {
                getRows: async (params) => {
                let stocks: any[] = [];
                let totalRows = 0;   
                await dispatch(getPriceGroupsStore({
                    groupBy: "None",
                    storeIds: [assignPriceGroup.currentStore],
                    offset: params.request.startRow,
                    limit: params.request.endRow != undefined && params.request.startRow != undefined ? params.request.endRow - params.request.startRow : 100,
                    managedStockDepartmentIds: (assignPriceGroup.currentDepartment > 0 ? [assignPriceGroup.currentDepartment] : undefined),
                    managedStockSubdepartmentIds: (assignPriceGroup.currentSubDepartment > 0 ? [assignPriceGroup.currentSubDepartment] : undefined),
                    managedStockStockGroupIds: (assignPriceGroup.managedStockGroupId > 0? [assignPriceGroup.managedStockGroupId]:undefined),
                    managedStockKeyword: assignPriceGroup.keyword,
                    managedStockContains: true,
                })).then((res) => {
                    if (res.data) {
                        stocks = res.data.sort((a, b) => a.managedStockName.localeCompare(b.managedStockName));
                        totalRows = res.totalRows;
                        dispatch(updateAssignPriceGroupField({ key: "stocks", value: stocks.map((stock: any) => { return { ...stock, id: stock.managedStockId } }) }));
                    }
                });

                if (stocks.length == 0) {
                    params.api.showNoRowsOverlay();
                    params.success({
                        rowData: [],
                        rowCount: 0
                    });
                    return;
                }
               
                params.api.hideOverlay();
                params.success({
                    rowData: stocks,
                    rowCount: totalRows,
                });
            }
        }
    }

    async function handleSubmit() {
        setSaving(true);
        setDisableModal(true);
        let stockIds: number[] = [];
        if (assignPriceGroup.selectedStocks.length === 0) {
            stockIds = assignPriceGroup.stocks.map((stock: any) => stock.managedStockId);
        } else {
            //@ts-ignore
            stockIds = assignPriceGroup.selectedStocks.flatMap((stockId: any) => stockId.map(i => i.id));
        }
        const payload: any = {
            filter: {
                storeIds: [assignPriceGroup.currentStore],
                managedDepartmentIds: assignPriceGroup.currentDepartment !== 0 ? [assignPriceGroup.currentDepartment] : [],
                managedStockIds: stockIds,
            },
            sync: true,
        }
        await dispatch(applyPriceGroupsStore(payload)).then((res) => {
            setShowModal(false);
            setDisableModal(false);
            setSaving(false);
            if(res.data){
                getStocksList();
                handleChange("selectedStocks", []);
            } 
        });
    }

    async function handleBulkPriceGroupsUpdate(priceGroupId: number, managedStockId: number[]) {
        let payload: any = [];
        managedStockId.forEach((stockId: number) => {
            payload.push({
                storeId: assignPriceGroup.currentStore,
                managedStockId: stockId,
                newPriceGroupId: priceGroupId
            })
        });
        await dispatch(modifyPriceGroupsStore(payload)).then((res) => {
            if (res.data) {
                handleChange("selectedStocks", []);
                handleChange("deselectedStocks", []);
            }
        });
    }

    async function saveBulkEdit(priceGroupId: number) {
        let stockIds: number[] = [];
        if (assignPriceGroup.selectedStocks.length === 0) {
            stockIds = assignPriceGroup.stocks.map((stock: any) => stock.managedStockId);
        } else {
            assignPriceGroup.selectedStocks.forEach((stock: any) => stockIds.push(stock.id));
        }
        await handleBulkPriceGroupsUpdate(priceGroupId, stockIds);
        await getStocksList();
        setBulkEditShow(false);
        columnCheckDeselectAll();
    }

    function handleChange(key: string, value: any) {
        dispatch(updateAssignPriceGroupField({ key: key, value: value }));
    }

    function onSearchClick(keyword: string | null) {        
        handleChange("keyword", keyword);
        if(keyword == assignPriceGroup.keyword){
            dispatch(getPriceGroupsStore({
                groupBy: "None",
                storeIds: [assignPriceGroup.currentStore],
                managedStockDepartmentIds: (assignPriceGroup.currentDepartment > 0 ? [assignPriceGroup.currentDepartment] : undefined),
                managedStockSubdepartmentIds: (assignPriceGroup.currentSubDepartment > 0 ? [assignPriceGroup.currentSubDepartment] : undefined),
                managedStockKeyword: assignPriceGroup.keyword,
                managedStockContains: true,
            }))
            .then(() =>{
                stockPriceGroupGridRef.current?.api.setGridOption("serverSideDatasource", getServerSideDatasource());
            });
        }
        else {
            dispatch(updateAssignPriceGroupField({ key: "keyword", value: keyword }));
        }	
        columnCheckDeselectAll();
    }

    function columnCheckDeselectAll() {
        stockPriceGroupGridRef.current?.api.deselectAll();
		handleChange("deselectedRows", []);
		handleChange("selectedRows", []);
	}

    return (
        <>
            <Row className="mb-2">
                <Col xs={3}>
                    <Form.Group>
                        <Form.Label className="form-check-label">Store</Form.Label>
                        <Form.Select
                            className="custom-select"
                            value={assignPriceGroup.currentStore}
                            onChange={(e) => dispatch(updateAssignPriceGroupField({ key: "currentStore", value: parseInt(e.target.value) }))}
                        >
                            <option hidden value="0">Choose a Store</option>
                            {stores.table.map((priceLevel: any, index: any) => {
                                return <option key={index} value={priceLevel.id}>{priceLevel.name}</option>
                            })}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col xs={3}>
                    <Form.Group>
                        <Form.Label className="form-check-label">Department</Form.Label>
                        <Form.Select
                            className="custom-select"
                            value={assignPriceGroup.currentDepartment}
                            onChange={(e) => dispatch(updateAssignPriceGroupField({ key: "currentDepartment", value: parseInt(e.target.value) }))}
                        >
                            <option value="0">All</option>
                            {departments.table.map((department: any, index: any) => {
                                return <option key={index} value={department.id}>{department.name}</option>
                            })}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col xs={3}>
                    <Form.Group>
                        <Form.Label className="form-check-label">Subdepartment</Form.Label>
                        <Form.Select
                            className="custom-select"
                            value={assignPriceGroup.currentSubDepartment}
                            onChange={(e) => dispatch(updateAssignPriceGroupField({ key: "currentSubDepartment", value: parseInt(e.target.value) }))}
                        >
                            <option value="0">All</option>
                            {assignPriceGroup.currentDepartment !== 0 && subDepartments.table.map((department: any, index: any) => {
                                return <option key={index} value={department.id}>{department.name}</option>
                            })}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col xs={3}>
                    <Form.Group>
                        <Form.Label className="form-check-label">Stock Groups</Form.Label>
                        <Form.Select
                            className="custom-select"
                            value={assignPriceGroup.managedStockGroupId ?? ""}
                            onChange={(e) => dispatch(updateAssignPriceGroupField({ key: "managedStockGroupId", value: parseInt(e.target.value) }))}
                        >
                            <option value="0">All</option>
                            {stockGroups.table.map((department: any, index: any) => {
                                return <option key={index} value={department.id}>{department.name}</option>
                            })}
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-1 ps-1 pe-1">
                <div className="page-container">
                    {bulkEditShow && <BulkEdit
                        show={bulkEditShow}
                        saveSelected={saveBulkEdit}
                        handleClose={() => setBulkEditShow(false)}
                        count={assignPriceGroup.selectedStocks.length}
                    />}
                    <Modal
                        title="Confirm - Stock level"
                        show={showModal}
                        buttonType="primary"
                        disableButtons={disableModal}
                        buttonText={disableModal ? "Applying..." : "Continue"}
                        handleClose={() => setShowModal(false)}
                        handleSubmit={handleSubmit}
                        description={
                            <>
                                <p>You are about to apply the new price group and sync the new sell prices.</p>
                                <p>Are you sure you want to continue?</p>
                            </>
                        }
                    />
                    <AgGridToolbar
                        search={true}
                        ref={toolbarRef}
                        className="my-2 px-1"
                        handleSubmit={(searchState, filterState) => {
                            onSearchClick(searchState?.keyword != undefined? searchState.keyword: null);
                        }}                      
                        searchProps={
                            { totalRows: assignPriceGroup.totalRows, placeholder: "by Name", hideContains: true}
                        }
                        children={(
                                <div className="d-inline-flex gap-1">
                                    { 
                                    (assignPriceGroup.selectedStocks != undefined && assignPriceGroup.selectedStocks.length != 0) &&									
                                        <Z.Button variant="light" className="h-100" disabled={true} buttonText={assignPriceGroup.selectedStocks.length + " Selected"}/>
                                    }
                                    {assignPriceGroup.selectedStocks.length > 1 &&
                                        <Button variant="light" className="me-1" onClick={() => setBulkEditShow(true)}> <i className="mdi mdi-pencil"></i></Button>
                                    }                    
                                    <ZTooltip text="Refresh">
                                        <Z.Button icon={ZIconType.Refresh} buttonSize="md" onClick={() => stockPriceGroupGridRef.current?.api.setGridOption("serverSideDatasource", getServerSideDatasource())} disabled={!user.permissions.priceGroups.canView} />
                                    </ZTooltip>
                             {/**       <Dropdown>
                                        <ZTooltip text="Export">
                                            <Dropdown.Toggle variant="light" className="btn-icon custom-btn-icon" style={{ height: 40 }}>
                                                <ZIcon icon={ZIconType.Download} size="18px" />
                                            </Dropdown.Toggle>
                                        </ZTooltip>
                                        <Dropdown.Menu className="w-auto">
                                            <Dropdown.Item className="d-inline-flex align-items-center gap-1" 
                                                onClick={() => {
                                                    stockPriceGroupGridRef.current?.api.exportDataAsCsv(getPriceGroupStockCsvDataFormatter()); }}>
                                                    <ZIcon icon={ZIconType.File} /> CSV File</Dropdown.Item>
                                            <Dropdown.Item className="d-inline-flex align-items-center gap-1" onClick={() => {
                                                let filters="";
                                                if(assignPriceGroup.keyword != null)
                                                    filters = "Search: "+ assignPriceGroup.keyword+ ", \r\n";

                                                const spreadSheets = [];
                                                spreadSheets.push(stockPriceGroupGridRef.current?.api.getSheetDataForExcel(getExportCoverPage(filters, "Price Groups")));
                                                spreadSheets.push(stockPriceGroupGridRef.current!.api.getSheetDataForExcel(getPriceGroupStockDataFormatter()));
                                                stockPriceGroupGridRef.current!.api.exportMultipleSheetsAsExcel({
                                                    data: spreadSheets,
                                                    fileName: "PriceGroupStock_" + new Date().toLocaleDateString('en-AU', {
                                                        day : 'numeric',
                                                        month : 'short',
                                                        year : 'numeric',
                                                        hour : '2-digit',
                                                        minute : '2-digit'
                                                    }).split(' ').join('-').replace(',', '') +".xlsx"
                                                });
                                            }}><ZIcon icon={ZIconType.Excel} /> Excel File</Dropdown.Item>									
                                        </Dropdown.Menu>
                                    </Dropdown>
                       */  }
                                </div>
                            )}
                        />

                    <AgGridReact
                        ref={stockPriceGroupGridRef} 
                        columnDefs={getPriceGroupStockConfig(assignPriceGroup, user, priceGroups)}
                        rowModelType="serverSide"
                        pagination={true}
                        paginationPageSize={20}
                        containerStyle={{ height: "68dvh" }}
                        className="ag-theme-quartz ag-theme-custom w-100"
                        rowSelection="multiple"
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        suppressContextMenu
                        excelStyles={getExportStyles()}                 
                        onRowSelected={() => {
                            let formatedData:{
                                positon: number,
                                id: number
                            } [] = []
                            var stocks = stockPriceGroupGridRef.current?.api.getSelectedRows(); 
                            stocks?.forEach((xe: any) => formatedData.push({ positon: 0, id: xe.managedStockId}));
                            console.log(formatedData);
                            dispatch(addAGGridSelectedStock(formatedData));
                        }}
                        components={{
                            baseCellRenderer: BaseCellRenderer,
                            priceCellRenderer: PriceCellRenderer, 
                            percentCellRenderer: PercentCellRenderer,
                        }}                        
                    />
                </div>
            </Row>
            <Row className="mt-3 mb-2">
                <Col sm={6}>
                </Col>
                <Col sm={6} className="d-flex flex-row-reverse">
                    <Button variant="primary" className="btn ms-1 cta-button" onClick={() => { setShowModal(true) }} disabled={!user.permissions.assignPriceGroups.canUpdate}>
                        {saving ? <Spinner className="spinner-border-sm me-1" tag="span" color="white" /> : null}
                        {saving ? "Applying..." : "Apply & Sync"}
                    </Button>
                </Col>
            </Row>
        </>
    );
}